export default __webpack_public_path__ + "e5a4cfc.png";